import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, BoxProps } from '@mui/material';
// hooks
import useSettings from '../hooks/useSettings';
//themes
import { T360LogoPrimary, T360LogoSecondary } from '../theme/logoColors';
// ----------------------------------------------------------------------

interface Props extends BoxProps {
    disabledLink?: boolean;
}

export default function ETGLogo({ disabledLink = true, sx }: Props) {
    const { themeMode } = useSettings();

    const PRIMARY_LOGO = themeMode === 'dark' ? T360LogoPrimary.dark : T360LogoPrimary.light;
    const SECONDARY_LOGO = themeMode === 'dark' ? T360LogoSecondary.dark : T360LogoSecondary.light;

    const logo = (
        <Box sx={{ width: 40, height: 40, ...sx }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 80 38">
                <defs>
                    <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
                        <stop offset="0%" stopColor={PRIMARY_LOGO} />
                        <stop offset="100%" stopColor={PRIMARY_LOGO} />
                    </linearGradient>
                    <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
                        <stop offset="0%" stopColor={SECONDARY_LOGO} />
                        <stop offset="100%" stopColor={SECONDARY_LOGO} />
                    </linearGradient>
                </defs>
                <g>
                    <g>
                        <path fill="url(#BG1)" d="M60.4,37.09h-4.09v-2.51c-1.54,1.84-4.02,2.92-6.91,2.92c-6.34,0-11.3-5.3-11.3-12.1
                            c0-6.8,4.96-12.14,11.3-12.14c5.16,0,9.12,2.92,10.56,7.74h-4.76c-0.9-2.04-3.12-3.72-5.8-3.72c-3.86,0-6.87,3.69-6.87,8.11
                            c0,4.39,3.12,8.08,7.07,8.08c3.32,0,5.9-2.28,6.74-5.2h-6.3v-4.12H60.4V37.09z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path fill="url(#BG1)" d="M17.64,37.09H0.41V13.83h17v4.12H4.83v4.96h10.73v4.12H4.83v5.93h12.81V37.09z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path fill="url(#BG1)" d="M30.98,17.95v19.14h-4.43V17.95h-6.24v-4.12h16.9v4.12H30.98z"/>
                    </g>
                </g>
                <polygon fill="url(#BG1)" points="64.78,5.76 70.03,0.5 65.34,0.5 57.84,8.01 65.34,15.51 70.03,15.51 64.78,10.26 72.09,10.26 
                    72.09,8.01 72.09,5.76 	"/>
                <polygon fill="url(#BG2)" points="72.65,21.17 67.4,26.42 72.09,26.42 79.59,18.92 72.09,11.42 67.4,11.42 72.65,16.67 65.34,16.67 
                    65.34,18.92 65.34,21.17 	"/>
            </svg>
        </Box>
    );

    if (disabledLink) {
        return <>{logo}</>;
    }

    return <RouterLink to="/">{logo}</RouterLink>;
}
